import {api} from "../../shared/utils";
import {environment} from "../../config/environment";

const baseUrl = environment.apiBaseURLClients;

const buildQuery = (params = {}) => {
    const query = new URLSearchParams();
    Object.entries(params).forEach(([key, value]) => {
        if (value == null || value === '') return;
        query.set(key, value);
    });
    return query.toString();
};

/* ---------- assinatura (app-licencas) ---------- */

export const listLicencas = (params = {}) => {
    const query = buildQuery(params);
    return api.get(`${baseUrl}/licencas${query ? `?${query}` : ''}`);
};

export const getLicenca = (id) => api.get(`${baseUrl}/licencas/${id}`);

// O POST ainda pede a chave de ativação; o tenant é gerado pelo backoffice e nunca vai no corpo (BBF-69).
export const createLicenca = (payload) => api.post(`${baseUrl}/licencas`, payload);

// O PUT pede id_empresa, id_plano, chave_ativacao e validade_inicio, e não muda plano, empresa, tenant nem
// situação. Aqui ele só troca o meio de pagamento (BBF-137).
export const updateLicenca = (id, payload) => api.put(`${baseUrl}/licencas/${id}`, payload);

// A mudança de situação exige motivo e grava o histórico da licença (BBF-3).
export const patchLicencaStatus = (id, status, motivo) => api.patch(`${baseUrl}/licencas/${id}/status`, {status, motivo});
export const resendLicencaNotifications = (id) => api.post(`${baseUrl}/licencas/resend-license/${id}`);

// Situação (`items`) e contrato (`contrato`: desconto, troca, cancelamento, opcionais), do mais recente (BBF-147).
export const getHistorico = (id) => api.get(`${baseUrl}/licencas/${id}/historico`);

/* ---------- contrato ---------- */

// Cancelar vale no fim do ciclo pago; no trial e aguardando o cartão, na hora (BBF-136).
export const cancelarLicenca = (id, motivo) => api.post(`${baseUrl}/licencas/${id}/cancelamento`, {motivo});
export const desistirDoCancelamento = (id, motivo) => api.delete(`${baseUrl}/licencas/${id}/cancelamento`, motivo ? {data: {motivo}} : undefined);

// Opcionais da versão: contratar vale na hora; tirar fica para o fim do ciclo pago (BBF-4).
export const getOpcionais = (id) => api.get(`${baseUrl}/licencas/${id}/opcionais`);
export const contratarOpcional = (id, idModulo) => api.post(`${baseUrl}/licencas/${id}/opcionais`, {id_modulo: idModulo});
export const retirarOpcional = (id, idModulo) => api.delete(`${baseUrl}/licencas/${id}/opcionais/${idModulo}`);

// Desconto sobre a mensalidade, com mês final AAAA-MM (BBF-106). O mesmo PUT dá e altera.
export const darDesconto = (id, desconto) => api.put(`${baseUrl}/licencas/${id}/desconto`, desconto);
export const removerDesconto = (id) => api.delete(`${baseUrl}/licencas/${id}/desconto`);

// Troca de plano ou de versão: upgrade na hora, downgrade na virada do ciclo (BBF-135).
export const trocarPlano = (id, idPlanoVersao) => api.post(`${baseUrl}/licencas/${id}/troca-de-plano`, {id_plano_versao: idPlanoVersao});
export const desfazerTroca = (id) => api.delete(`${baseUrl}/licencas/${id}/troca-de-plano`);

/* ---------- o que a assinatura mostra de outros apps ---------- */

// A seção desta assinatura na próxima fatura da empresa, pelo cálculo único (BBF-24).
export const getPreviaDaLicenca = (id) => api.get(`${baseUrl}/financeiro/licencas/${id}/previa`);

export const getEmpresa = (id) => api.get(`${baseUrl}/empresas/${id}`);
export const getVersaoDoPlano = (planoId, numero) => api.get(`${baseUrl}/planos-licenciamento/${planoId}/versoes/${numero}`);
export const listPlanosDoSistema = (sistemaId) => api.get(`${baseUrl}/planos-licenciamento?${buildQuery({id_sistema: sistemaId, page: 1, pageSize: 100, sortBy: 'nome_plano', order: 'asc'})}`);
export const listModulosDoSistema = (sistemaId) => api.get(`${baseUrl}/modulos?${buildQuery({sistema_id: sistemaId, page: 1, pageSize: 100, sortBy: 'nome', order: 'asc'})}`);

export const listEmpresasReference = () => api.get(`${baseUrl}/empresas?page=1&pageSize=100&sortBy=razao_social&order=asc`);
export const listPlanosReference = () => api.get(`${baseUrl}/planos-licenciamento?page=1&pageSize=100&sortBy=nome_plano&order=asc`);
